<template>
  <div class="approval-report-wrapper flex">
    <d-search :searchData="searchData" @searchEvent="searchList(1)" @exportEvent="exportList" @resetEvent="reset">
      <time-search ref="timeSearch" :param.sync="searchData.params" :options="$map.getter('BPMtimeTags')"  :default-select="7"></time-search>
    </d-search>
    <div class="inline-flex contentBox">
      <d-table :tableData="tableData" :columnData="columnData" class="contentTable">
        <el-table-column label="节点耗时" prop="nodeTimeConsuming" slot="nodeTimeConsuming">
          <template slot-scope="{row}">
            <span :class="{'colorRed':row.isTimeOutNode}">{{row.nodeTimeConsuming}}</span>
          </template>
        </el-table-column>
        <el-table-column label="本人耗时" prop="selfTimeConsuming" slot="selfTimeConsuming">
          <template slot-scope="{row}">
            <span :class="{'colorRed':row.isTimeOutSelf}">{{row.selfTimeConsuming}}</span>
          </template>
        </el-table-column>
      </d-table>
    </div>
    <d-paging :pager="pager" @change="searchList"></d-paging>
  </div>
</template>

<script>
import TimeSearch from "@/pages/statement/approval-report/components/time-search";
import DSearch from "@/components/d-search";
import DTable from "@/components/d-table";
import DPaging from "@/components/d-paging";
import {onDownload} from "@/utils/utils";
import {Arrays} from "@/utils/Arrays";
import {searchPeopleCondition} from "@/pages/statement/approval-report/components/peopleMixin";
export default {
  name: "member-detail-statistics",
  mixins:[searchPeopleCondition],
  components: {DPaging, DTable, DSearch, TimeSearch},
  data() {
    return {
      peopleList:[],
      searchData: {
        searchItem: [
          {label:'审批人',value:'dealUser',type:'linkageSelect',options:this.peopleList,filterable:true,optionProps:{
              label: "name",value: "value",children:"children",emitPath:false
            }
          },
          {label:'流程编号',value:'processNumber',type:'commonInput'}
        ],
        params: {
          dealUser: '',
          processNumber:'',
          startTime: '',
          endTime: ''
        },
        searchBtn: {
          queryBtn: true,
          resetBtn: true,
          exportBtn: true
        }
      },
      tableData: [],
      columnData: [
        {label: '审批人', prop: 'approveUser'},
        {label: '审批部门', prop: 'approveDept'},
        {label: '流程编号', prop: 'processNumber'},
        {label: '审批类型', prop: 'activitiName'},
        {label: '节点名称', prop: 'nodeName'},
        {label: '节点操作时间', prop: 'nodeOverTime'},
        {label: '节点耗时', prop: 'nodeTimeConsuming',slot:true},
        {label: '本人耗时', prop: 'selfTimeConsuming',slot:true}
      ],
      pager: {
        count: 0,
        page: 1,
        rows: 10,
      }
    }
  },
  mounted(){
    this.searchList()
  },
  methods:{
    _getParams(){
      return {
        dealUser:this.searchData.params.dealUser,
        processNumber:this.searchData.params.processNumber,
        endDate:this.searchData.params.endTime,
        startDate:this.searchData.params.startTime,
        pageNum: this.pager.page,
        pageSize: this.pager.rows
      }
    },
    // 查询列表
    searchList(page){
      if(!this.$refs.timeSearch.validate()) return ;
      page && (this.pager.page = 1,this.pager.rows = 10)
      this.$api.mentapi.aprMemberDetailList(this._getParams()).then(({data})=>{
        this.tableData = data.records;
        this.pager.count = data.total;
      })
    },

    getPeople(){
      this.$api.personnel.sysPeopleTree().then((res) => {
        this.peopleList = new Arrays().map([res.data], (item) => {
          item.children && !item.children.length && item.userId && delete item.children;
          item.value = (item.mobile || 'd-'+item.deptId)+'' ;
          item.name = item.name;
          return item;
        })
        this.searchData.searchItem.forEach(ele => {
          if (ele.value === 'dealUser') {
            ele.options = this.peopleList
          }
        })
      });
    },

    // 导出
    exportList(){
      this.$api.mentapi.aprMemberDetailExport({...this._getParams(),pageSize:10000,pageNum:1}).then(({headers,data})=>{
        onDownload(headers,data)
      })
    },

    reset(){
      this.$refs.timeSearch.reset();
      this.searchList()
    }
  }
}
</script>

<style scoped>

</style>